<!--
    @负责人: 谢汉
    @创建时间: 2018-08-07
    @版本:v1.0.20
    @描述: 应用管理-状态维护
    -->
<template>
  <div class="statusManager__content">
    <g-back :history="history"></g-back>
    <div class="mb-base mr-base ilb">
      <span class="statusManager__siteName">{{ $t('logComponentManage.site') }}</span>
      <g-select class="statusManager__siteSelect" :list="siteList" v-model="siteCode"></g-select>
    </div>
    <div class="statusManager__search ilb">
      <el-input :placeholder="'Search...'" @keyup.native="search" v-model="inputVal"></el-input>
    </div>
    <div class="tree-wrap" v-show="primaryData.length > 0">
      <div class="tree-wrap-item" v-for="(item,index) in treeData" :key="index">
        <tree :tree-data="item" :tree-id="item.name" @selecttree="amendStatus"></tree>
      </div>
    </div>
    <div class="mt-base"
      v-show="primaryData.length === 0"
      v-text="$t('common.noData')"
      style="text-align: center;"></div>
    <el-dialog :closeOnClickModal="false"
      :title="$t('appManager.running')+'-'+selectName"
      :visible.sync="iVisible"
      width="400px">
      <el-form ref="form">
        <div class="ilb mr-base app-status app-status-run"
          :class="{'selected-status': selectStatus === '1'}"
          @click="selectStatus = '1'">
          {{ $t('appManager.running') }}
        </div>
        <div class="ilb app-status app-status-stop"
          :class="{'selected-status': selectStatus === '2'}"
          @click="selectStatus = '2'">
          {{ $t('appManager.stopping') }}
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="e_cancel">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="e_save"  v-g-rac="gRac('statusManager@save')">{{ $t('common.save') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import SiteListBiz from '@/logic/cmdb/cmdbBiz'
  import rac from '@/plugins/rac-mixin'
  import appManagerBiz from '@/logic/cmdb/appManagerBiz'
  import { extend, debounce } from '@/utils/tool'
  import tree from '../../component/appManger/tree'
  export default {
    mixins: [rac],
    data () {
      const that = this
      return {
        history: [],
        primaryData: [],
        treeData: null,
        selectGroup: '',
        selectName: '',
        selectStatus: '',
        selectId: '',
        siteList: {},
        siteCode: '',
        groupIndex: '',
        appIndex: '',
        searchTimer: null,
        search: debounce(that.e_search, 500),
        inputVal: '',
        iVisible: false
      }
    },
    components: {
      tree
    },
    methods: {
      init () {
        this.history = []
        this.history.push({ name: this.$t('appManager.statusManager'), path: '/home/appManager' })
      },
      getSiteList () {
        SiteListBiz.siteList({perPageCount: 500}).then((data) => {
          let list = {}
          data.dataList.map((item) => {
            list[item.siteCode] = item.name
          })
          this.siteList = list
          this.siteCode = Object.keys(list)[0]
        })
      },
      e_getData () {
        appManagerBiz.getAppStatus({ siteCode: this.siteCode }).then((data) => {
          let dataArr = data
          // 深拷贝
          this.primaryData = []
          dataArr.map((item) => {
            this.primaryData.push(extend(true, {}, item))
          })
          this.translateToTreeData([])
          this.$nextTick(() => {
            this.translateToTreeData(dataArr)
          })
        })
      },
      translateToTreeData (data) {
        let groupArr = data.filter((item) => item.groupName === null)
        groupArr.map((item) => {
          item.children = data.filter((_item) => _item.groupName === item.name)
        })
        this.treeData = []
        groupArr.map((item, index) => {
          let childStatus2 = item.children.filter(_item => _item.status === '2').length
          if (childStatus2 > 0 && childStatus2 < item.children.length) {
            item.status = '3'
          }
          this.$set(this.treeData, index, item)
        })
        this.treeData.sort(function (a, b) {
          return (b.children.length - a.children.length)
        })
      },
      amendStatus (info) {
        this.selectName = info.data.name
        this.selectGroup = info.data.groupName
        this.selectStatus = info.data.status
        this.selectId = info.data.id
        this.iVisible = true
      },
      e_cancel () {
        this.iVisible = false
      },
      e_search () {
        this.treeData = []
        let groupArr = this.primaryData.filter((item) => {
          return (item.groupName === null && item.name.indexOf(this.inputVal) !== -1)
        })
        let appArr = []
        groupArr.map((item) => {
          appArr = [ ...appArr, ...this.primaryData.filter((_item) => (item.name === _item.groupName)) ]
        })
        let treeArr = [ ...appArr, ...groupArr ]
        this.$nextTick(() => this.translateToTreeData(treeArr))
      },
      e_save () {
        let saveData = {
          id: this.selectId,
          status: this.selectStatus
        }
        if (this.selectGroup) {
          this.findIndex()
          if (this.checkGroupStatus()) return
          appManagerBiz.updateAppStatus(saveData).then(() => {
            this.successCallBack()
            this.updateAppStatus()
          })
        } else {
          this.findIndex(false)
          appManagerBiz.updateGroupStatus(saveData).then(() => {
            this.successCallBack()
            this.updateGroupStatus()
          })
        }
      },
      successCallBack () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        this.iVisible = false
      },
      findIndex (app = true) {
        if (app) {
          this.groupIndex = this.treeData.findIndex((item) => {
            return item.name === this.selectGroup
          })
          this.appIndex = this.treeData[this.groupIndex].children.findIndex((item) => {
            return item.name === this.selectName
          })
        } else {
          this.groupIndex = this.treeData.findIndex((item) => {
            return item.name === this.selectName
          })
        }
      },
      updateAppStatus () {
        let appObj = this.treeData[this.groupIndex].children[this.appIndex]
        appObj.status = this.selectStatus
        this.treeData[this.groupIndex].children.splice(this.appIndex, 1, appObj)
        let childStatus2 = this.treeData[this.groupIndex].children.filter(_item => _item.status === '2').length
        if (childStatus2 > 0 && childStatus2 < this.treeData[this.groupIndex].children.length) {
          this.treeData[this.groupIndex].status = '3'
        } else if (childStatus2 === this.treeData[this.groupIndex].children.length) {
          this.treeData[this.groupIndex].status = '2'
        } else if (childStatus2 === 0) {
          this.treeData[this.groupIndex].status = '1'
        }
        this.updatePrimaryStatus(this.selectName)
      },
      updateGroupStatus () {
        this.treeData[this.groupIndex].children.map((item, index) => {
          if (item.status !== this.selectStatus) {
            let appObj = item
            appObj.status = this.selectStatus
            this.treeData[this.groupIndex].children.splice(index, 1, appObj)
          }
        })
        this.treeData[this.groupIndex].status = this.selectStatus
        this.updatePrimaryStatus(this.selectName, false)
      },
      updatePrimaryStatus (name, app = true) {
        let nameIndex = this.primaryData.findIndex((item) => {
          return name === item.name
        })
        this.primaryData[nameIndex].status = this.selectStatus
        if (!app) {
          this.primaryData.map((item) => {
            if (item.groupName === name) {
              item.status = this.selectStatus
            }
          })
        }
      },
      // 检查所属组是否是维护态
      checkGroupStatus () {
        if (this.treeData[this.groupIndex].status === '2' && this.selectStatus === '1') {
          this.$message({
            message: this.$t('appManager.groupStopAlert'),
            type: 'warning'
          })
        }
        return (this.treeData[this.groupIndex].status === '2' && this.selectStatus === '1')
      }
    },
    watch: {
      '$route' (newV, oldV) {
        if (oldV.name === 'appManager' && newV.name === 'statusManager') {
          this.getSiteList()
        } else if (newV.name === 'appManager' && oldV.name === 'statusManager') {
          this.inputVal = ''
        }
      },
      siteCode () {
        this.e_getData()
        this.inputVal = ''
      }
    },
    mounted () {
      this.init()
      this.getSiteList()
    }
  }
</script>

<style scoped>
  .statusManager__content .statusManager__siteName {
    font-weight: 700;
    font-size: 16px;
    padding: 0 10px;
  }
  .statusManager__content .statusManager__siteSelect {
    width: 200px;
  }
  .statusManager__content .tree-wrap {
    -moz-column-count: 2; /* Firefox */
    -webkit-column-count: 2; /* Safari 和 Chrome */
    column-count: 2;
    -moz-column-gap: 2em;
    -webkit-column-gap: 2em;
    column-gap: 2em;
  }
  .statusManager__content .tree-wrap-item {
    width: 460px;
    margin-bottom: 40px;
    -moz-page-break-inside: avoid;
    page-break-inside: avoid;
    -webkit-column-break-inside: avoid;
    break-inside: avoid;
  }
  .statusManager__content .app-status {
    width: 160px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #ddd;
    border-radius: 10px;
    cursor: pointer;
  }
  .statusManager__content .app-status-run {
    background: #24d46d;
  }
  .statusManager__content .app-status-stop {
    background: #ffdc53;
  }
  .statusManager__content .selected-status {
    border: 2px solid #3385ff;
  }
  .statusManager__search {
    width: 200px;
  }
</style>